/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ideapa-form-field-wrapper',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      label {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-weight: 500;
      }

      .feedback {
        font-size: 12px;
      }

      .hint {
        opacity: 0.6;
      }
    `,
  ],
  template: `
    <ng-template #tipContent>{{ tooltip }}</ng-template>
    <label class="text-secondary d-flex align-items-center">
      <span>{{ label }}</span>
    
      @if (tooltip.length > 0) {
        <ideapa-icon-button
          tabindex="-1"
          class="ms-2 tip"
          icon="info"
          cssClasses="text-primary"
          [ngbTooltip]="tipContent"
          iconFontSize="16px"
          ></ideapa-icon-button
          >
        }</label>
        <ng-content></ng-content>
        @if (showHint || shouldShowError) {
          @for (err of errors; track err) {
            <div
              class="feedback"
              [class.invalid-feedback]="shouldShowError"
              [class.hint]="!shouldShowError"
              >
              {{ err }}
            </div>
          }
        }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldWrapperComponent {
  @Input()
  label = '';

  @Input()
  tooltip = '';

  @Input()
  errors: string[] = [];

  @Input()
  shouldShowError = false;

  @Input()
  showHint = true;
}
